import React from "react";
import { Skeleton } from "antd";
import error404 from "../../assets/img/error404.png";

const NotFound = () => {
  return (
    <Skeleton loading={false}>
      <div style={{ textAlign: "center" }}>
        <img
          src={error404}
          style={{ width: "100%" }}
          alt="Por el momento no hay información para mostrar."
        ></img>
      </div>
    </Skeleton>
  );
};

export default NotFound;